import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

// Delivery commitments are floating server-local times, not UTC browser instants.
export const deliveryDateLabel = value => value?.replace("T", " ") || "—";

export function DeliveryScheduleChange({event, zone}) {
    const {t} = useTranslation();
    if (event.description !== "OrderShipmentRescheduled" || !event.reason) {return null;}
    const dates = event.reason.split(" -> ");
    return <Typography variant="body2" sx={{mt: 0.5}}>
        {dates.length === 2 ? t("DeliveryScheduleChanged", {from: deliveryDateLabel(dates[0]), to: deliveryDateLabel(dates[1])}) : event.reason}
        {zone && ` (${zone})`}
    </Typography>;
}

export default function OrderDeliverySchedule({products, zone}) {
    const {t} = useTranslation();
    const accepted = products.filter(product => product.productCount > 0);
    const dates = [...new Set(accepted.map(product => product.deliveryDate).filter(Boolean))].sort();
    const original = [...new Set(accepted.map(product => product.originalDeliveryCommitment).filter(Boolean))].sort();
    const rescheduled = original.length && dates.length && JSON.stringify(original) !== JSON.stringify(dates);
    return <Box sx={{p: 1.5, mb: 2, bgcolor: "action.hover", borderRadius: 1}}>
        <Typography variant="subtitle2">{t("CurrentDeliverySchedule")}{zone && ` (${zone})`}</Typography>
        <Typography variant="body2" fontWeight={600}>{dates.length ? dates.map(deliveryDateLabel).join(" · ") : t("DeliveryNotScheduled")}</Typography>
        {Boolean(rescheduled) && <Typography variant="body2" color="text.secondary">
            {t("OriginalDeliveryCommitment")}: {original.map(deliveryDateLabel).join(" · ")}
        </Typography>}
    </Box>;
}
